var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "bvModal",
      attrs: {
        id: "place_images_modal",
        "no-close-on-backdrop": true,
        "hide-footer": true,
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c("div", { staticClass: "modal-header-buttons-container" }, [
                _c("div", { staticClass: "mobile-header-placeholder" }),
                _c("h2", [_vm._v(_vm._s(_vm.$t("placeImagesModal.title")))]),
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "close-modal-btn mr-7",
                      attrs: { id: "place_images_modal_close_btn" },
                      on: {
                        click: function ($event) {
                          close()
                          _vm.reset()
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "feather feather-x",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "28",
                            height: "28",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("line", {
                            attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                          }),
                          _c("line", {
                            attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "bb-btn btn-success header-save-btn",
                    on: {
                      click: function ($event) {
                        return _vm.submit()
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("placeImagesModal.saveBtn")) + " "
                    ),
                  ]
                ),
              ]),
              _c("div", { staticClass: "modal-header-title-container" }, [
                _c("h2", [_vm._v(_vm._s(_vm.$t("placeImagesModal.title")))]),
              ]),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-center align-items-center" },
        [
          _c("div", { staticClass: "bb-card" }, [
            _c("div", { staticClass: "card-header" }, [
              _c("span", { staticClass: "card-title" }, [
                _vm._v(_vm._s(_vm.$t("placeImagesModal.card.title"))),
              ]),
            ]),
            _c("input", {
              ref: "imageInput",
              staticStyle: { display: "none" },
              attrs: { type: "file", multiple: "" },
              on: { change: _vm.onFileChange },
            }),
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _vm._l(_vm.place.images, function (image) {
                  return _c(
                    "div",
                    { key: image.id, staticClass: "image-item" },
                    [_c("img", { attrs: { src: image.url } })]
                  )
                }),
                _vm._l(_vm.uploadedImages, function (image, index) {
                  return _c("div", { key: index, staticClass: "image-item" }, [
                    _c("img", { attrs: { src: image.url } }),
                  ])
                }),
                _c(
                  "div",
                  {
                    staticClass: "image-item",
                    on: {
                      click: function ($event) {
                        return _vm.uploadImage()
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "image-placeholder" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "44",
                            height: "48",
                            viewBox: "0 0 44 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M25.7059 7.21622H5.94118C4.63069 7.21622 3.37389 7.74015 2.44724 8.67277C1.52059 9.60538 1 10.8703 1 12.1892V37.0541M1 37.0541V42.027C1 43.3459 1.52059 44.6108 2.44724 45.5434C3.37389 46.4761 4.63069 47 5.94118 47H35.5882C36.8987 47 38.1555 46.4761 39.0822 45.5434C40.0088 44.6108 40.5294 43.3459 40.5294 42.027V32.0811M1 37.0541L12.3301 25.651C13.2567 24.7187 14.5133 24.195 15.8235 24.195C17.1338 24.195 18.3903 24.7187 19.3169 25.651L25.7059 32.0811M40.5294 19.027V32.0811M40.5294 32.0811L36.6111 28.1375C35.6844 27.2052 34.4279 26.6815 33.1176 26.6815C31.8074 26.6815 30.5508 27.2052 29.6242 28.1375L25.7059 32.0811M25.7059 32.0811L30.6471 37.0541M33.1176 5.97297H43M38.0588 1V10.9459M25.7059 17.1622H25.7306",
                              stroke: "#99ACC2",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]
                ),
              ],
              2
            ),
          ]),
        ]
      ),
      _c("div", { staticClass: "mobile-footer" }, [
        _c(
          "button",
          {
            staticClass: "bb-btn btn-success",
            on: {
              click: function ($event) {
                return _vm.submit()
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t("placeImagesModal.saveBtn")) + " ")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }